import ProductUpdateAuthorForm from './product-update-author-form'

export default ProductUpdateAuthorForm;